import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';

const Navbar = () => {
  const { count, setCartOpen } = useCart();
  const navigate = useNavigate();

  return (
    <Nav>
      <Logo onClick={() => navigate('/')}>ARGO</Logo>
      <NavLinks>
        <NavLink onClick={() => navigate('/')}>Shop Now</NavLink>
        <NavLink href="#">Our Story</NavLink>
        <NavLink href="#">Find Us</NavLink>
        <NavLink href="#">Blog</NavLink>
      </NavLinks>
      <CartButton onClick={() => { setCartOpen(true); }}>
        Cart {count > 0 && <CartBadge>{count}</CartBadge>}
      </CartButton>
    </Nav>
  );
};

export default Navbar;

const Nav = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem 3rem;
  background: linear-gradient(to bottom, rgba(10,10,10,0.95) 0%, transparent 100%);
`;

const Logo = styled.a`
  font-family: var(--font-display);
  font-size: 2rem;
  color: var(--accent);
  text-decoration: none;
  letter-spacing: 0.08em;
  cursor: pointer;
  &:hover { color: var(--accent-light); }
`;

const NavLinks = styled.div`
  display: flex;
  gap: 2.5rem;
`;

const NavLink = styled.a`
  font-family: var(--font-condensed);
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: var(--white);
  text-decoration: none;
  cursor: pointer;
  transition: color 0.25s ease;
  &:hover { color: var(--accent); }
`;

const CartButton = styled.button`
  position: relative;
  font-family: var(--font-condensed);
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: var(--white);
  background: transparent;
  border: 1.5px solid var(--white-dim);
  border-radius: 999px;
  padding: 0.55rem 1.6rem;
  cursor: pointer;
  transition: all 0.25s ease;
  &:hover { background: var(--accent); border-color: var(--accent); }
`;

const CartBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--accent);
  color: var(--white);
  font-size: 0.6rem;
  font-weight: 700;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin-left: 6px;
  vertical-align: middle;
`;
